export default function passwordsMatch (value, allValues) {
  const passwordRegex = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{10,})/
  if (!passwordRegex.test(value)) {
      return "Password must contain at least 1 uppercase letter, 1 number, 1 special character, and be at least 10 characters long"
  }
  if (allValues.password !== allValues["confirm-password"]) {
      return 'Password and Password Confirmation must match';
  }
  return;
};